/**
 * Canonical brand palette — change colors here and in `src/styles/brand-variables.css`
 * (plain CSS cannot import JS; keep the two files aligned when tokens change).
 *
 * Use in React: `import { brandPalette } from "../constants/brandPalette"`
 * Use in Chakra: `color="brand.primary"` etc. (see chakra.config.js)
 * Use in .css: `color: var(--brand-primary)`
 */

export const brandInk = "#2E2A26";

export const brandPalette = {
  primary: "#5B0D16",
  /** Darker hover / pressed (legacy accent) */
  accentDark: "#450B11",
  secondary: "#702933",
  wine: "#852F3D",
  crimson: "#9C4654",
  cream: "#F7F2EC",
  paper: "#FBF9F6",
  sand: "#F4EFE9",
  warmBeige: "#EDE6DD",
  stone: "#D5CDC5",
  taupe: "#958D85",
};

/** RGB tuples (no `rgb()`) for `rgba(var(--brand-*-rgb), a)` in CSS or template strings */
export const brandRgb = {
  primary: "91, 13, 22",
  secondary: "112, 41, 51",
  stoneWash: "213, 205, 197",
};

/** Chakra `styles.global.body` — same visual as legacy inline gradients */
export const brandBodyGlobalStyle = {
  bg: brandPalette.cream,
  backgroundImage: `radial-gradient(ellipse 120% 80% at 85% 5%, rgba(${brandRgb.primary}, 0.07) 0%, transparent 52%), radial-gradient(ellipse 100% 70% at 5% 95%, rgba(${brandRgb.secondary}, 0.06) 0%, transparent 48%), radial-gradient(ellipse 90% 60% at 50% 50%, rgba(${brandRgb.stoneWash}, 0.45) 0%, transparent 55%)`,
  backgroundAttachment: "fixed",
};

/** Chakra `colors.brand` scale-style object (flat names for clarity) */
export const brandChakraColors = {
  maroon: brandPalette.primary,
  burgundy: brandPalette.secondary,
  wine: brandPalette.wine,
  crimson: brandPalette.crimson,
  cream: brandPalette.cream,
  white: brandPalette.paper,
  sand: brandPalette.sand,
  beige: brandPalette.warmBeige,
  stone: brandPalette.stone,
  taupe: brandPalette.taupe,
};
